import { useContext, useEffect, useMemo, useState } from "react";
import "./receivingItem.css";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import Input from "../../../../../components/Inputs/Input";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { FileUploader } from "../../../../../components/FileUploader/FileUploader";

import Skeleton from "react-loading-skeleton";
import { Popover, Tooltip } from "@mui/material";
import {
  getNLAHierarchySvc,
  receiveOrder,
} from "../../../Services/receivingManagementService";
import MultioptionButton from "../../../../../components/Buttons/MultioptionButton";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import { localStorageSave } from "../../../../../services/localStorageService";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { NewDiscrepancyModal } from "../NewDiscrepancyModal/NewDiscrepancyModal";
import { NLAExpandable } from "./NLAExpandable/NLAExpandable";
import { ReceivingNlaModal } from "./ReceivingNla/ReceivingNlaModal";
import { useDispatch, useSelector } from "react-redux";
import { setParts } from "../../../../../redux/features/StoresModule/nlaReceivingSlice";
import { TextAreaComponent } from "../../../../../components/TextArea/TextAreaComponent";
import { ReceivingUploadFile } from "./ReceivingUploadFile/ReceivingUploadFile";
import { ExistingDiscrepancyModal } from "../ExistingDiscrepancyModal/ExistingDiscrepancyModal";

const uomIdToAbbr = {
  1: "H", // Hours
  2: "D", // Days
  3: "M", // Months
  4: "Y", // Years
  5: "KG", // Kilograms
  6: "LB", // Pounds
  7: "G", // Grams
  8: "OZ", // Ounces
  9: "M", // Meters
  10: "CM", // Centimeters
  11: "MM", // Millimeters
  12: "IN", // Inches
  13: "FT", // Feet
  14: "L", // Liters
  15: "ML", // Milliliters
  16: "GAL", // Gallons
  17: "QT", // Quarts
  18: "EA", // Each
  19: "LBIN", // Inch-pound
  20: "LBFT", // Foot-pound
  21: "NM", // Newton-meter
  22: "m²", // Square meter
  23: "cm²", // Square centimeter
  24: "ha", // Hectare
  25: "ft²", // Square foot
  26: "in²", // Square inch
  27: "yd²", // Square yard
  28: "mm²", // Square millimeter
  29: "C", // Cycles
  30: "Date", // Date
};

const UOM_CONVERSIONS = {
  weight: {
    KG: { KG: 1, LB: 2.20462, G: 1000, OZ: 35.274 },
    LB: { KG: 0.453592, LB: 1, G: 453.592, OZ: 16 },
    G: { KG: 0.001, LB: 0.00220462, G: 1, OZ: 0.035274 },
    OZ: { KG: 0.0283495, LB: 0.0625, G: 28.3495, OZ: 1 },
  },
  volume: {
    L: { L: 1, ML: 1000, GAL: 0.264172, QT: 1.05669 },
    ML: { L: 0.001, ML: 1, GAL: 0.000264172, QT: 0.00105669 },
    GAL: { L: 3.78541, ML: 3785.41, GAL: 1, QT: 4 },
    QT: { L: 0.946353, ML: 946.353, GAL: 0.25, QT: 1 },
  },
  length: {
    M: { M: 1, CM: 100, MM: 1000, IN: 39.3701, FT: 3.28084 },
    CM: { M: 0.01, CM: 1, MM: 10, IN: 0.393701, FT: 0.0328084 },
    MM: { M: 0.001, CM: 0.1, MM: 1, IN: 0.0393701, FT: 0.00328084 },
    IN: { M: 0.0254, CM: 2.54, MM: 25.4, IN: 1, FT: 0.0833333 },
    FT: { M: 0.3048, CM: 30.48, MM: 304.8, IN: 12, FT: 1 },
  },
};

export function convertUOM(value, from, to) {
  for (const category in UOM_CONVERSIONS) {
    if (
      UOM_CONVERSIONS[category][from] &&
      UOM_CONVERSIONS[category][from][to]
    ) {
      const factor = UOM_CONVERSIONS[category][from][to];
      return value * factor;
    }
  }
  return null; // No conversion possible
}

// export const buildTreeFromFlatArray = (flatArray) => {
//   // Crear un mapa para acceso rápido por partId (agrupando por partId + positions para unicidad)
//   const nodeMap = new Map();
//   const roots = [];

//   //crear todos los nodos únicos con una clave compuesta
//   flatArray.forEach((item) => {
//     const uniqueKey = `${item.partId}-${item.positions}`;

//     const node = {
//       ...item,
//       children: [],
//       nlaQty: 1,
//       et: [],
//     };

//     nodeMap.set(uniqueKey, node);
//   });

//   nodeMap.forEach((node) => {
//     if (node.parentPartId === null || node.parentPartId === undefined) {
//       // Es una raíz (nivel 1)
//       roots.push(node);
//     } else {
//       // Necesitamos encontrar el padre con el mismo partId y la posición correspondiente
//       const parentKey = `${node.parentPartId}-${node.positions}`;
//       const parent = nodeMap.get(parentKey);

//       if (parent) {
//         if (!parent.children.includes(node)) {
//           parent.children.push(node);
//         }
//       } else {
//         // Si no encontramos el padre exacto, buscar cualquier padre con el partId correcto
//         let foundParent = null;
//         nodeMap.forEach((potentialParent) => {
//           if (potentialParent.partId === node.parentPartId && !foundParent) {
//             foundParent = potentialParent;
//           }
//         });

//         if (foundParent && !foundParent.children.includes(node)) {
//           foundParent.children.push(node);
//         } else {
//           // Si aún no encontramos padre, es una raíz
//           roots.push(node);
//         }
//       }
//     }
//   });

//   return roots;
// };

const receivingDraftPrefix = "store/receiving/draft/";
// export const buildTreeFromFlatArray = (flatArray) => {
//   const nodeMap = new Map();
//   const roots = [];

//   // Paso 1: Crear TODOS los nodos (incluyendo duplicados)
//   flatArray.forEach((item, index) => {
//     // Usar índice para hacer cada clave única y mantener todos los registros
//     const uniqueKey = `${item.partId}-${item.positions || 'default'}-${index}`;

//     const node = {
//       ...item,
//       children: [],
//       nlaQty: 1,
//       et: [],
//     };

//     nodeMap.set(uniqueKey, node);
//   });

//   // Paso 2: Crear un mapa auxiliar por partId para búsqueda rápida
//   const nodesByPartId = new Map();
//   nodeMap.forEach((node) => {
//     if (!nodesByPartId.has(node.partId)) {
//       nodesByPartId.set(node.partId, []);
//     }
//     nodesByPartId.get(node.partId).push(node);
//   });

//   // Paso 3: Construir la jerarquía para TODOS los nodos
//   nodeMap.forEach((node) => {
//     if (node.parentPartId && node.parentPartId !== null) {
//       const parents = nodesByPartId.get(node.parentPartId) || [];

//       // Asignar este nodo a TODOS los padres posibles
//       parents.forEach(parent => {
//         if (!parent.children.includes(node)) {
//           parent.children.push(node);
//         }
//       });

//       // Si no tiene padres pero tiene parentPartId, es una raíz
//       if (parents.length === 0) {
//         roots.push(node);
//       }
//     } else {
//       // No tiene parentPartId, es una raíz
//       roots.push(node);
//     }
//   });
//   console.log(roots , "roots")
//   return roots;
// };

// treeUtils.js o en el mismo archivo

export const ReceivingItem = ({ data, reload }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDraft, setIsDraft] = useState(false);
  const [certificateNameUploaded, setCertificateNameUploaded] = useState("");
  const [form, setForm] = useState({
    status: "Vendor Approved",
    id: null,
    parent_order_id: null,
    part_id: null,
    part_number: "",
    description: "",
    quantity_order: 0,
    uom_id: null,
    abreviation: "",
    category: "",
    original_detail_id: null,
    sub_category: "",
    prn_count: 0,
    order_type: "",
    company_name: "",
    location_id: null,
    vendor_name: "",
    vendor_id: null,
    location_code: "",
    site_id: null,
    site_name: "",
    supply_chain: null,
    wp_count: 0,
    prn: null,
    wp: "",
    tc_fnd: null,
    company_id: null,

    // additional properties than does not come from backend data
    qty: data.quantity,
    serialNumber: "",
    shelfLife: "",
    receivingNotes: "",
    weight: 0,
    weightUnit: null,
    certificateNumber: "",
    certificateType: null,
    tagBy: "",
    tagDate: "",
    tagNumber: "",
    file: null,
    awb_id: null,
    vendorLot: null,
    binId: null,
    partConditionId: null,
  });

  const [dataPartSelected, setDataPartSelected] = useState({
    partUOMId: null,
    partWeightId: null,
    partWeight: null,
  });

  const orderUOMAbbr = uomIdToAbbr[data.uom_id];
  const partUOMAbbr = uomIdToAbbr[dataPartSelected.partUOMId];
  const quantity = form.qty;
  let discrepancyMessage = "";
  const [edition, setEdition] = useState(false);
  const [fileURL, setFileURL] = useState(null);
  const { openDialog, closeDialog } = useContext(DialogContext);

  // dropdowns configs
  const [pnDrop, setPnDrop] = useState(null);
  const [conditionDrop, setConditionDrop] = useState(null);
  const [AWBDrop, setAWBDrop] = useState(null);
  const [locationsDrop, setLocationsDrop] = useState(null);
  const [sitesDrop, setSitesDrop] = useState(null);
  const [rackDrop, setRackDrop] = useState(null);
  const [shelvesDrop, setShelvesDrop] = useState(null);
  const [binsDrop, setBinsDrop] = useState(null);
  const [weightUnitDrop, setWeightUnitDrop] = useState(null);
  const [uomDrop, setUomDrop] = useState(null);
  const [partIdParam, setPartIdParam] = useState(null);
  const [certificateDrop, setCertficateDrop] = useState(null);

  // ERRORS STATES
  const [hasPNError, setHasPNError] = useState(false);
  const [hasAWBIdError, setHasAWBIdError] = useState(false);
  const [hasUomError, setHasUomError] = useState(false);
  const [hasSerializedError, setHasSerializedError] = useState(false);

  const [hasLocationError, setHasLocationError] = useState(false);
  const [hasSiteError, setHasSiteError] = useState(false);
  const [hasRackError, setHasRackError] = useState(false);
  const [hasShelfError, setHasShelfError] = useState(false);
  const [hasVendorLotError, setHasVendorError] = useState(false);
  const [hasCerificateNumberError, setHasCerificateNumberError] =
    useState(false);
  const [hasCerificateTypeError, setHasCerificateTypeError] = useState(false);

  // preselection of dropdowns state
  const [preselectAWB, setPreselectAWB] = useState(null);
  const [preselectPart, setPreselectPart] = useState(null);
  const [preselectPartCondition, setPreselectPartCondition] = useState(null);
  const [preselectLocation, setPreselectLocation] = useState(null);
  const [preselectSite, setPreselectSite] = useState(null);
  const [preselectRack, setPreselectRack] = useState(null);
  const [preselectShelf, setPreselectShelf] = useState(null);
  const [preselectBin, setPreselectBin] = useState(null);
  const [preselecUomId, setPreselecUomId] = useState(null);
  const [preselectWeightId, setPreselecWeightId] = useState(null);

  const { successMsg } = useSnackBar();
  const dispatch = useDispatch();
  const partNLAs = useSelector((state) => state.receivingNla.parts ?? []);
  const [awbParameter, setAwbParameter] = useState(null);
  // funtions

  const toggleOpen = () => {
    setIsOpen((prevState) => !prevState);
  };
  const getDropdownConfigPN = async () => {
    let id = 129;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPnDrop(request.data.load);
    }
  };

  // const getDropdownConfigSN = async () => {
  //     let id = 69;
  //     const request = await dropdownConfig(id);
  //     if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
  //         setsnDrop(request.data.load);
  //     }
  // };

  const getDropdownConfigCondition = async () => {
    let id = 96;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setConditionDrop(request.data.load);
    }
  };

  const getDropdownConfigAWB = async () => {
    let id = 132;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAWBDrop(request.data.load);
    }
  };

  const getDropdownConfigLocation = async () => {
    let id = 17;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationsDrop(request.data.load);
    }
  };

  const getDropdownConfigSite = async () => {
    let id = 137;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSitesDrop(request.data.load);
    }
  };
  const getDropdownConfigRack = async () => {
    let id = 79;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setRackDrop(request.data.load);
    }
  };

  const getDropdownConfigShelves = async () => {
    let id = 97;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setShelvesDrop(request.data.load);
    }
  };

  const getDropdownConfigBin = async () => {
    let id = 99;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setBinsDrop(request.data.load);
    }
  };

  const getDropdownConfigWeight = async () => {
    let id = 135;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setWeightUnitDrop(request.data.load);
    }
  };
  const getDropdownConfigUOM = async () => {
    let id = 6;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setUomDrop(request.data.load);
    }
  };
  const getDropdownConfigCertificate = async () => {
    let id = 134;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCertficateDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigLocation(),
      getDropdownConfigPN(),
      // getDropdownConfigSN(),
      getDropdownConfigCondition(),
      getDropdownConfigSite(),
      getDropdownConfigRack(),
      getDropdownConfigShelves(),
      getDropdownConfigBin(),
      getDropdownConfigWeight(),
      getDropdownConfigUOM(),
      getDropdownConfigAWB(),
      getDropdownConfigCertificate(),
    ]);

    return results;
  };

  const handleInputsChanges = (e) => {
    setForm((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const validateForm = () => {
    const partIdValid = !!form.part_id;
    const locationValid = !!form.location_id;
    const siteValid = !!form.site_id;
    const rackValid = !!form.rack;
    const shelfValid = !!form.shelf;
    const vendorLotValid = !!form.vendorLot;
    const certificateNumberValid = !!form.certificateNumber;
    const certificateTypeValid = !!form.certificateType;

    const isSerialized = data.category === "Serialized";
    const validUOMId = isSerialized ? true : !!form.uom_id;
    const validSerialized = !isSerialized ? true : !!form.serialNumber;

    setHasPNError(!partIdValid);
    setHasLocationError(!locationValid);
    setHasSiteError(!siteValid);
    setHasRackError(!rackValid);
    setHasShelfError(!shelfValid);
    setHasVendorError(!vendorLotValid);
    setHasCerificateNumberError(!certificateNumberValid);
    setHasCerificateTypeError(!certificateTypeValid);
    setHasUomError(isSerialized ? false : !validUOMId);
    setHasSerializedError(isSerialized && !validSerialized);

    return (
      partIdValid &&
      locationValid &&
      siteValid &&
      rackValid &&
      shelfValid &&
      vendorLotValid &&
      certificateNumberValid &&
      certificateTypeValid &&
      validUOMId &&
      validSerialized
    );
  };

  const sendReceive = async () => {
    if (!validateForm()) {
      return;
    }
    const formData = new FormData();

    formData.append("partId", form.part_id ?? 0);
    form.serialNumber &&
      formData.append("serialNumber", form.serialNumber ?? "");
    form.partConditionId &&
      formData.append("partConditionId", form.partConditionId ?? 0);
    formData.append("locationId", form.location_id);
    formData.append("siteId", form.site_id);
    formData.append(
      "quantityReceived",
      data.category == "Serialized" ? form.quantity : form.qty
    );

    formData.append("vendorId", form.vendor_id ?? null);
    // formData.append("manufacturerId", 0);
    formData.append("rackId", form.rack ?? null);
    formData.append("shelfId", form.shelf ?? null);
    form.binId && formData.append("binId", form.binId);
    form.shelfLife && formData.append("shelfLifeDate", form.shelfLife ?? null);
    formData.append("toolLifeDate", "Wed Jul 30 2025 00:00:00 GMT-0500");
    form.receivingNotes &&
      formData.append("receivingNotes", form.receivingNotes ?? "");
    formData.append("orderDetailId", form.original_detail_id ?? null);
    formData.append("vendorLot", form.vendorLot ?? "");
    form.weight && formData.append("weight", form.weight?.toString() ?? null);
    form.weightUnit &&
      formData.append(
        "weightUnitId",
        data.category !== "Serialized" ? form.uom_id : data.uom_id
      );
    formData.append("certificateNumber", form.certificateNumber ?? "");
    formData.append("certificateTypeId", form.certificateType);
    formData.append("companyId", form.company_id ?? 0);
    form.tagBy && formData.append("tagBy", form.tagBy ?? "");
    form.tagDate &&
      formData.append("tagDate", form.tagDate || new Date().toISOString());
    form.tagNumber && formData.append("tagNumber", form.tagNumber ?? "");
    formData.append("currencyId", data.currency_id);
    formData.append("costPerUnit", data.unit_price);
    formData.append("awbId", form.awb_id ?? null);

    // formData.append("receiveId", 0);
    if (form.file instanceof File) {
      formData.append("file", form.file);
    }

    try {
      const request = await receiveOrder(formData);
      if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        successMsg("Order Received", "Order Has Been Received Successfully.");
        setEdition(false);
        setIsOpen(false);
        reload();
      }
    } catch (error) {
      console.error("Error sending Form:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setForm((prevForm) => ({
      ...prevForm,
      file: file,
    }));
    setCertificateNameUploaded(event.target.files[0].name);
  };

  const handleDeleteCertificate = () => {
    setForm((prevForm) => ({
      ...prevForm,
      file: null,
    }));
  };

  const handleDownloadCertificate = () => {
    if (!fileURL) return;

    const fileName = fileURL.split("/").pop();

    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 17:
        setDropdown = setLocationsDrop;
        break;
      case 137:
        setDropdown = setSitesDrop;
        break;
      case 79:
        setDropdown = setRackDrop;
        break;
      case 97:
        setDropdown = setShelvesDrop;
        break;
      case 99:
        setDropdown = setBinsDrop;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReload = () => {
    setLocationsDrop((prevState) => ({ ...prevState, reload: false }));
    setSitesDrop((prevState) => ({ ...prevState, reload: false }));
    setRackDrop((prevState) => ({ ...prevState, reload: false }));
    setShelvesDrop((prevState) => ({ ...prevState, reload: false }));
    setBinsDrop((prevState) => ({ ...prevState, reload: false }));
  };

  const saveInDraft = () => {
    try {
      localStorageSave(
        receivingDraftPrefix,
        { receiveOrderId:data.__unique_serial_id },
        form
      );
      successMsg("Data Saved", "Data has been saved in draft successfully.");
      setEdition(false);
    } catch (error) {
      console.warn(error , "ksaj")
    }
  };

  const multiOptionsBtn = [
    { label: "Save Draft", icon: "icon-save", id: "save" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => saveInDraft(),
    // "save-continue": () => {},
    cancel: () => {
      setEdition(false);
    },
  };
  const getReceivingNLA = async (partId) => {
    let request = await getNLAHierarchySvc(partId);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      dispatch(setParts([...request.data.load]));
    }
  };

  const openNLADialog = () => {
    openDialog({
      component: ReceivingNlaModal,
      props: {
        onclose: closeDialog,
        part_id: data.part_id,
        pn: form.part_number,
        serialNum: form.serialNumber,
        description: form.description,
        isPurchaseOrder: form.order_type == "PO",
      },
    });
  };

  const openUploadFileDialog = () => {
    openDialog({
      component: ReceivingUploadFile,
      props: {},
    });
  };

  useEffect(() => {
    if (isOpen) {
      getReceivingNLA(data.part_id);
    }
    setAwbParameter([
      {
        columnName: "awbId",
        value: data.awb_id,
      },
    ]);
    setPartIdParam([
      {
        columnName: "partId",
        value: data.part_id,
      },
    ]);
  }, [data.part_id, isOpen, data.awb_id]);
  // const saveDraft = () => {
  //   localStorageSave();
  // };

  const preloadFormData = (data) => {
    if (!isDraft) {
      setForm({
        ...form,
        ...data,
      });
      setPreselectLocation(data.location_id);
      setPreselectSite(data.site_id);
      setPreselectPart(data.part_id);
      setPreselecUomId(data.uom_id);
      setPreselectAWB(data?.awb_id);
    } else {
      // develop logic to load draft data Here...
    }
  };
  useEffect(() => {
    if (isOpen) {
      getAllDropdowns();
    }
  }, [isOpen]);

  useEffect(() => {
    // if (isOpen) {
    preloadFormData(data);
    // }
  }, [data]);

  useEffect(() => {
    if (form.file) {
      const url = URL.createObjectURL(form.file);
      setFileURL(url);

      return () => URL.revokeObjectURL(url);
    }
  }, [form.file]);

  useEffect(() => {
    setPreselecWeightId(dataPartSelected.weight_uom_id);
  }, [dataPartSelected]);

  const [convertedString, setConvertedString] = useState("");

  function getConvertedUnitString(qty, fromId, toId) {
    if (!qty || !fromId || !toId)
      return (
        <p className="receiving-warning-parts-discrepancy">
          A conversion for the units of measurement could not be performed.
        </p>
      );
    if (fromId === toId) return `${qty} ${uomIdToAbbr[fromId]}`;

    const fromAbbr = uomIdToAbbr[fromId];
    const toAbbr = uomIdToAbbr[toId];

    for (const category in UOM_CONVERSIONS) {
      if (
        UOM_CONVERSIONS[category][fromAbbr] &&
        UOM_CONVERSIONS[category][fromAbbr][toAbbr]
      ) {
        const factor = UOM_CONVERSIONS[category][fromAbbr][toAbbr];
        const convertedQty =
          Math.round((qty * factor + Number.EPSILON) * 100) / 100;

        return (
          <p className="receiving-warning-parts-discrepancy">
            The unit of measure does not match the PN's unit of measure. The
            total of
            <strong>
              {" "}
              {qty} {fromAbbr}{" "}
            </strong>
            equals
            <strong>
              {" "}
              {convertedQty} {toAbbr}{" "}
            </strong>
            , which is the unit of measure associated with the PN.
          </p>
        );
      }
    }

    return (
      <p className="receiving-warning-parts-discrepancy">
        No conversion available between these units From order UOM :{" "}
        <strong>{fromAbbr}</strong> To part UOM : <strong>{toAbbr}</strong>.
      </p>
    );
  }
  useEffect(() => {
    if (isOpen) {
      const result = getConvertedUnitString(
        form.qty,
        form.uom_id,
        dataPartSelected.uom_id
      );
      setConvertedString(result);
    }
  }, [form.qty, dataPartSelected, form.uom_id]);

  const openDiscrepancyDialog = () => {
    openDialog({
      component: NewDiscrepancyModal,
      props: {
        onclose: closeDialog,
        qtyOrdered: data.quantity_order,
        UOMId: data.uom_id,
        company_id: data.company_id,
        orderId: data.original_detail_id,
        status: form.status,
        styles : {width : "26vw" , height : "60vh"}
      },
    });
    setAnchorPos(null);
  };

  const [anchorPos, setAnchorPos] = useState(null);

  const handleClose = () => {
    setAnchorPos(null);
  };

  const openPopOver = (event) => {
    setAnchorPos({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const openexistingDiscrepancyDialog = ()=>{
    openDialog({
      component: ExistingDiscrepancyModal,
      props: {
        onClose: closeDialog,
        // qtyOrdered: data.quantity_order,
        // UOMId: data.uom_id,
        // company_id: data.company_id,
        // orderId: data.original_detail_id,
        // status: form.status,
      },
    });
  }
  return (
    <section className="receivingItem">
      <section
        className={` receinving-item-header  ${
          isOpen ? "item-open-header item-sticky-header" : "item-closed-header"
        }`}
        onClick={toggleOpen}
        // style={{
        //   backgroundColor: isOpen ? "#EFFCFF" : "#FBFBFB",
        //   border: isOpen ? "1px solid #B9D8DF" : " var(--item-border)",
        // }}
        onContextMenu={(e) => {
          e.stopPropagation();
          e.preventDefault();
          openPopOver(e);
        }}
      >
        {/* <span className="editing-status-receiving-span">Editing</span> */}
        <div className="receiving-item-icon-warning" onClick={(e)=>{
          e.stopPropagation()
          openexistingDiscrepancyDialog()
        }}>
              <span class="icon-coloredwarning">
                <span class="path1"></span>
                <span class="path2"></span>
              </span>
            </div>
        <p className="ellipsis">{data.id || form.id || "--"}</p>
        <p className="ellipsis">
          {data?.order_type || form.order_type || "--"}
        </p>
        <p className="ellipsis">
          {data?.parent_order_id || form?.parent_order_id || "--"}
        </p>
        <p className="ellipsis">
          {data?.part_number || form?.part_number || "--"}
        </p>
        <p className="ellipsis">{data?.category || form?.category || "--"}</p>
        <p className="ellipsis">
          {data?.quantity_order || form?.quantity_order || "--"}
        </p>
        <p className="ellipsis">{data?.quantity || form?.quantity || "--"}</p>
        <p className="ellipsis">
          {data?.description || form?.description || "--"}
        </p>
        {/* <p>{data?.serialNumber || form?.serialNumber || "--"}</p> */}
        <p className="ellipsis">
          {data?.location_code || form?.location_code || "--"}
        </p>
        <p className="ellipsis">{data?.site_name || form?.site_name || "--"}</p>
        <p className="ellipsis">
          {data?.vendor_name || form?.vendor_name || "--"}
        </p>
        <p className="ellipsis">
          {data?.supply_chain || form?.supply_chain || "--"}
        </p>
        <p className="ellipsis">
          {data?.company_name || form?.company_name || "--"}
        </p>
      </section>

      <Popover
        id="simple-popover"
        open={Boolean(anchorPos)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={anchorPos}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div
          className="create-discrepancy-receiving"
          onClick={openDiscrepancyDialog}
        >
          New Discrepancy
        </div>
      </Popover>

      {isOpen && (
        <section className={`receiving-item-content ${isOpen ? "open" : ""}`}>
          <div className="receiving-item-content-header">
            <h3>Order Information</h3>
            {edition ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "var(--gap)",
                }}
              >
                <button
                  onClick={(e) => {
                    sendReceive();
                  }}
                  className="receive-btn-form"
                >
                  Receive{" "}
                  <i
                    className="icon-icon_Received"
                    style={{
                      fontSize: "1rem",
                    }}
                  ></i>
                </button>
                <MultioptionButton
                  buttons={multiOptionsBtn}
                  buttonCallbacks={buttonsCallback}
                ></MultioptionButton>
              </div>
            ) : (
              <button
                className="btn-edit-receiving"
                onClick={(e) => {
                  setEdition(true);
                }}
              >
                <i className="icon-edit"></i> Edit
              </button>
            )}
          </div>

          {isOpen && (
            <section className="receiving-item-form">
              <div>
                <section className="receiving-item-general-info">
                  <h3>General Information</h3>
                  <div>
                    {pnDrop ? (
                      <Dropdowns
                        disabled={!edition}
                        data={pnDrop}
                        onOptionSelect={(e) => {
                          setForm((prev) => {
                            return {
                              ...prev,
                              part_id: e.id,
                              part_number: e.part_number,
                              weight: e.part_weight,
                            };
                          });
                          setPreselectPart(e.id);
                          setDataPartSelected(e);
                        }}
                        preSelectValue={preselectPart}
                        required={true}
                        activateErrorHint={hasPNError}
                        parameters={partIdParam}
                        preventSelectionWithPreselect={false}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                    <i
                      style={{
                        fontSize: "1.3rem",
                        color: "var(--black-mid)",
                      }}
                      className="icon-info"
                    ></i>
                  </div>
                  <div>
                    {data.category == "Serialized" ? (
                      <Input
                        error={hasSerializedError}
                        disabled={!edition}
                        label="*Serial Number"
                        name="serialNumber"
                        value={form.serialNumber}
                        onChange={(e) => {
                          handleInputsChanges(e);
                          setHasSerializedError(false);
                        }}
                        upperCase={true}
                      />
                    ) : (
                      <>
                        <Input
                          disabled={!edition}
                          label="QTY"
                          name="qty"
                          value={form.qty}
                          onChange={handleInputsChanges}
                          isNumeric={true}
                        />
                        {uomDrop && (
                          <Dropdowns
                            required={true}
                            activateErrorHint={hasUomError}
                            disabled={!edition}
                            data={uomDrop}
                            preSelectValue={preselecUomId}
                            onOptionSelect={(e) => {
                              setForm((prev) => {
                                // return { ...prev, uom_id: e.id, abreviation: e.label }
                                return { ...prev, uom_id: e.id };
                              });

                              setPreselecUomId(e.id);
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                  {data.category !== "Serialized" &&
                    dataPartSelected.uom_id !== form.uom_id &&
                    dataPartSelected.uom_id && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <span className="icon-coloredwarning">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </span>{" "}
                        {convertedString}
                      </div>
                    )}

                  <div style={{}}>
                    {conditionDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns
                          disabled={!edition}
                          data={conditionDrop}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, partConditionId: e.id };
                            });
                            setPreselectPartCondition(e.id);
                          }}
                          preSelectValue={preselectPartCondition}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                    {AWBDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns //AWB drop
                          disabled={!edition || !!data?.awb_id}
                          preSelectValue={preselectAWB}
                          data={AWBDrop}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, awb_id: e["an.id"] };
                            });
                          }}
                          parameters={awbParameter}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                  </div>

                  <div>
                    {locationsDrop ? (
                      <div
                        style={{
                          width: "49%",
                        }}
                      >
                        <Dropdowns //locations drop
                          disabled={!edition}
                          updateDropdown={updateDropdown}
                          resetDropdownsReload={resetDropdownsReload}
                          data={locationsDrop}
                          required={true}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, location: e.id };
                            });
                            setPreselectLocation(e.id);
                            setPreselectSite(null);
                            setPreselectRack(null);
                            setPreselectShelf(null);
                            setPreselectBin(null);
                          }}
                          preSelectValue={preselectLocation}
                          activateErrorHint={hasLocationError}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                    {sitesDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns //sites drop
                          disabled={!edition}
                          updateDropdown={updateDropdown}
                          resetDropdownsReload={resetDropdownsReload}
                          data={sitesDrop}
                          required={true}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, site: e.id };
                            });
                            setPreselectSite(e.id);
                            setPreselectRack(null);
                            setPreselectShelf(null);
                            setPreselectBin(null);
                          }}
                          preSelectValue={preselectSite}
                          activateErrorHint={hasSiteError}
                          // optionLabel={"site_code"}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                  </div>
                  <div>
                    {rackDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns //rack drop
                          disabled={!edition}
                          required={true}
                          activateErrorHint={hasRackError}
                          data={rackDrop}
                          updateDropdown={updateDropdown}
                          resetDropdownsReload={resetDropdownsReload}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, rack: e.id };
                            });
                            setPreselectRack(e.id);
                            setPreselectShelf(null);
                            setPreselectBin(null);
                          }}
                          preSelectValue={preselectRack}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                    {shelvesDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns //shelves drop
                          disabled={!edition}
                          data={shelvesDrop}
                          required={true}
                          activateErrorHint={hasShelfError}
                          updateDropdown={updateDropdown}
                          resetDropdownsReload={resetDropdownsReload}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, shelf: e.id };
                            });
                            setPreselectShelf(e.id);
                            setPreselectBin(null);
                          }}
                          preSelectValue={preselectShelf}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                  </div>
                  <div>
                    {binsDrop ? (
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <Dropdowns //bins drop
                          data={binsDrop}
                          disabled={!edition}
                          updateDropdown={updateDropdown}
                          resetDropdownsReload={resetDropdownsReload}
                          onOptionSelect={(e) => {
                            setForm((prev) => {
                              return { ...prev, binId: e.id };
                            });
                            setPreselectBin(e.id);
                          }}
                          preSelectValue={preselectBin}
                        ></Dropdowns>
                      </div>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                    <button className="reciving-general-info-require-btn">
                      {" "}
                      <i
                        className="icon-info"
                        style={{
                          fontSize: "1rem",
                        }}
                      ></i>{" "}
                      Requires Inspection{" "}
                    </button>
                  </div>
                </section>
                <section className="receiving-item-life-exp">
                  <h3>Life & Expiry</h3>
                  <div>
                    <BasicDatePicker
                      label={"Shelf Life"}
                      disabled={!edition}
                      style={{
                        width: "50%",
                      }}
                      onChange={(e) => {
                        setForm((prev) => {
                          return { ...prev, shelfLife: e.$d };
                        });
                      }}
                      value={form.shelfLife}
                    ></BasicDatePicker>
                    <BasicDatePicker
                      label={"Tool Life"}
                      disabled={true}
                      style={{
                        width: "50%",
                      }}
                      onChange={(e) => {}}
                    ></BasicDatePicker>
                  </div>
                  <div>
                    <h2>Additional Info</h2>
                  </div>
                  <div
                    style={{
                      height: "30%",
                    }}
                  >
                    {/* <textarea
                      disabled={!edition}
                      className="receiving-item-additional-info-textarea"
                      value={form.receivingNotes}
                      name="receivingNotes"
                      onChange={handleInputsChanges}
                    ></textarea> */}
                    <TextAreaComponent
                      disabled={!edition}
                      value={form.receivingNotes}
                      name={"receivingNotes"}
                      onChange={handleInputsChanges}
                      label={"Receiving Notes"}
                    ></TextAreaComponent>
                  </div>
                  <div>
                    <Input
                      upperCase={true}
                      label={"*Vendor Lot"}
                      disabled={!edition}
                      error={hasVendorLotError}
                      value={form.vendorLot}
                      name={"vendorLot"}
                      onChange={(e) => {
                        handleInputsChanges(e);
                        setHasVendorError(false);
                      }}
                    ></Input>
                  </div>
                  <div>
                    <Input
                      disabled={true}
                      label={"Weight"}
                      isNumeric={true}
                      allowDecimals={true}
                      value={form.weight}
                      name={"weight"}
                      onChange={handleInputsChanges}
                    ></Input>
                    {weightUnitDrop ? (
                      <Dropdowns
                        disabled={true}
                        data={weightUnitDrop}
                        // onOptionSelect={(e) => {
                        //     setForm((prev) => {
                        //         return { ...prev, weightUnit: e.id }
                        //     })
                        // }}
                        preSelectValue={preselectWeightId}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                  </div>
                </section>
                <section className="receiving-item-certificates">
                  <h3>Certificates</h3>
                  <div>
                    {certificateDrop ? (
                      <Dropdowns
                        data={certificateDrop}
                        disabled={!edition}
                        required={true}
                        activateErrorHint={hasCerificateTypeError}
                        optionLabel={"name"}
                        onOptionSelect={(e) => {
                          setForm((prev) => {
                            return { ...prev, certificateType: e.id };
                          });
                          setHasCerificateTypeError(false);
                        }}
                      ></Dropdowns>
                    ) : (
                      <Skeleton height={"2rem"}></Skeleton>
                    )}
                  </div>
                  <div>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <Input
                        disabled={!edition}
                        label={"*Certificate Number"}
                        error={hasCerificateNumberError}
                        value={form.certificateNumber}
                        name={"certificateNumber"}
                        onChange={(e) => {
                          handleInputsChanges(e);
                          setHasCerificateNumberError(false);
                        }}
                        upperCase={true}
                      ></Input>
                    </div>
                  </div>

                  <div
                    style={{
                      background: "var(--white)",
                      // height : "4rem"
                    }}
                  >
                    {form.file == null ? (
                      <div
                        style={{
                          height: "3rem",
                          width: "100%",
                        }}
                      >
                        <FileUploader
                          disable={!edition}
                          label={"Upload Certificate"}
                          onUpload={(e) => {
                            handleFileChange(e);
                          }}
                          iconLabel={"icon-certificate"}
                        ></FileUploader>
                      </div>
                    ) : (
                      <section className="receiving-file-uploaded">
                        <i className="icon-list"></i>

                        <Tooltip title="View Certificate" arrow>
                          <a
                            href={fileURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              cursor: "pointer",
                              width: "80%",
                            }}
                          >
                            <p className="ellipsis">
                              {certificateNameUploaded}
                            </p>
                          </a>
                        </Tooltip>

                        <Tooltip title="Download Certificate" arrow>
                          <i
                            onClick={handleDownloadCertificate}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              right: "1.8rem",
                              color: "var(--grey-200)",
                            }}
                            className="icon-download"
                          ></i>
                        </Tooltip>

                        <Tooltip title="Delete Certificate" arrow>
                          <i
                            onClick={handleDeleteCertificate}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              right: ".48rem",
                            }}
                            className="icon-delete-new"
                          ></i>
                        </Tooltip>
                      </section>
                    )}
                  </div>
                  <div>
                    <h2>Tag Info</h2>
                  </div>
                  <div>
                    <Input
                      disabled={!edition}
                      label={"Tag By"}
                      value={form.tagBy}
                      name={"tagBy"}
                      onChange={handleInputsChanges}
                      upperCase={true}
                    ></Input>
                  </div>
                  <div>
                    <BasicDatePicker
                      disabled={!edition}
                      label={"Tag Date"}
                      onChange={(e) => {
                        setForm((prev) => {
                          return { ...prev, tagDate: e.$d };
                        });
                      }}
                    ></BasicDatePicker>
                    <Input
                      disabled={!edition}
                      label={"Tag Number"}
                      value={form.tagNumber}
                      name={"tagNumber"}
                      onChange={handleInputsChanges}
                      upperCase={true}
                    ></Input>
                  </div>
                </section>
              </div>
              <section
                className="receiving-item-NLA-cont"
                // style={{
                //   width: "45%",
                // }}
              >
                <div>
                  <Tooltip
                    title={!edition ? "Enable Edition To Acces." : ""}
                    arrow
                  >
                    <button onClick={openNLADialog} disabled={!edition}>
                      <i className="icon-more-horizontal"></i>
                    </button>
                  </Tooltip>
                  <h3>NLA PN SN</h3>
                  <div className="receiving-item-NLA-cont-pn-data">
                    <p>
                      PN <span>{form.part_number}</span>
                    </p>
                    {data.category == "Serialized" && (
                      <p>
                        SN{" "}
                        <span>
                          {form.serialNumber ? form.serialNumber : "--"}
                        </span>
                      </p>
                    )}
                    {/* <p
                      style={{
                        marginLeft: "auto",
                      }}
                    >
                      Vendor Lot <span>{form.vendorLot ?? "--"}</span>
                    </p> */}
                  </div>
                  <button
                    className="receiving-NLA-import-file-btn"
                    onClick={openUploadFileDialog}
                  >
                    Import From File
                  </button>
                </div>
                {/* <section> */}

                {/* <span>
                    <p>PN</p>
                    <p>SN</p>
                    <p>Vendor Lot</p>
                    <p>NLA QTY</p>
                    <p>ET QTY</p>
                  </span> */}
                {/* <NLAExpandable
                    data={mockNLAData}
                    idx={0}
                    totalLength={mockNLAData.children.length ?? 0}
                    depth={0}
                  ></NLAExpandable> */}

                {/* <div
                    style={{
                      width: "100%",
                      height: "calc(80% - var(--padding))",
                      display: "flex",
                      flexDirection: "column",
                      gap: "var(--gap)",
                      overflow: "hidden auto",
                      background: "none",
                      border: "none",
                    }}
                  >
                    {nlasTree.map((node, idx) => (
                      <NLAExpandable
                        key={`${node.partId}-${node.positions}-${idx}`}
                        data={node}
                        idx={idx}
                        parentLength={node.children.length}
                        depth={0}
                      />
                    ))}
                  </div> */}
                {/* </section> */}
              </section>
            </section>
          )}
        </section>
      )}
    </section>
  );
};
